import * as constants from '../constants/actions';
import * as storage from '../persistance/storage';

const initDiamonds = { 
  // shape: 'Round,Oval,Cushion',
  // caratMin: 0.50,
  // caratMax: 4.00,
  // color: 'F,G,H,I',
  // clarityMin: 'SI2',
  // clarityMax: 'VS2',
};

const initSettings = {
  type: 'engagement',
  // priceMin: 500,
};

const initMensBand = {
  type: 'mensband',
  // finish: 'polished,matte',
  // carved: 'classic,milgrain,textured,engraved,diamond',
  // priceMin: 500,
};

const initWomensBand = {
  type: 'womensband',
  // priceMin: 300,
};

const initFashion = {
  type: 'ring,earring,necklace,bracelet',
  // priceMin: 100,
};

const initMensJewelry = {
  type: 'mring,mnecklace,chains,mbracelet',
  // priceMin: 100,
};


// const initFashionRing = {
//   type: 'ring',
//   // settingtype: 'Solitaire,ThreeStone,Halo,Pave',
// };

// const initFashionEarring = {
//   type: 'engagement',
//   // settingtype: 'Solitaire,ThreeStone,Halo,Pave',
// };

// const initFashionNecklace = {
//   type: 'engagement',
//   // settingtype: 'Solitaire,ThreeStone,Halo,Pave',
// };

// const initFashionBracelet = {
//   type: 'engagement',
//   // settingtype: 'Solitaire,ThreeStone,Halo,Pave',
// };

let selDiamond = storage.get('selectedDiamond') ? JSON.parse(storage.get('selectedDiamond')) : null;
let selSetting = storage.get('selectedSetting') ? JSON.parse(storage.get('selectedSetting')) : null;

const initialState = {
	diamondResults: null,
  diamondResultsCount: null,
  // diamondFilters: storage.get('diamondFilters') ? JSON.parse(storage.get('diamondFilters')) : initDiamonds,
  diamondFilters: initDiamonds,
  
  productResults: null,
  productResultsCount: null,
  productResultsType: null,
  // productFilters: storage.get('productFilters') ? JSON.parse(storage.get('productFilters')) : initSettings,
  productFilters: {},

  selectedDiamond: selDiamond,
  selectedSetting: selSetting,

  floatingHeaderOpen: false,
  // floatingHeaderOpen: selDiamond !== null || selSetting !== null,

  compareDiamonds: [],
  compareSettings: [],
  compareBands: [],
  compareFashion: [],

  currentPage: 1,
  currentDiamondPage: 1,

  attrSize: storage.get('attrSize') ? storage.get('attrSize') : '',
  attrMetal: storage.get('attrMetal') ? storage.get('attrMetal') : '',
};



export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.PRODUCT_SAVE_DIAMONDS:
      return productSaveDiamondResults(state, action);
    case constants.PRODUCT_SAVE_SETTINGS:
      return productSaveSettingResults(state, action);
    case constants.PRODUCT_SAVE_DIAMOND_QUERY:
      return productSaveDiamondFilters(state, action);
    case constants.PRODUCT_SAVE_SETTING_QUERY:
      return productSaveSettingFilters(state, action);
    case constants.PRODUCT_SELECT_SETTING:
      return productSelectSetting(state, action);
    case constants.PRODUCT_SELECT_DIAMOND:
      return productSelectDiamond(state, action);
    case constants.PRODUCT_COMPARE_SETTING:
      return productCompareSetting(state, action);
    case constants.PRODUCT_COMPARE_DIAMOND:
      return productCompareDiamond(state, action);
    case constants.PRODUCT_COMPARE_BAND:
      return productCompareBand(state, action);
    case constants.PRODUCT_COMPARE_FASHION:
      return productCompareFashion(state, action);
    case constants.PRODUCT_CLEAR_QUERY:
      return productClearQuery(state, action);
    case constants.PRODUCT_SET_PAGE: 
      return productSetPage(state, action);
    case constants.PRODUCT_ADD_DIAMONDS:
      return productAddDiamondsResults(state, action);

    case constants.PRODUCT_RESET_DIAMOND_QUERY:
      return productResetDiamondFilters(state, action);
    case constants.PRODUCT_RESET_PRODUCT_QUERY: 
      return productResetProductFilters(state, action);

    case constants.PRODUCT_ATTR_SIZE:
      return productAttrSize(state, action);
    case constants.PRODUCT_ATTR_METAL: 
      return productAttrMetal(state, action);
    case constants.PRODUCT_FLOATING_HEADER_TOGGLE:
      return productToggleFloatingHeader(state, action);

    case constants.PRODUCT_APPEND_DIAMONDS:
      return productAppendDiamondResults(state, action);

    default:
      return state;
  }
}

function productSaveDiamondResults(state, action) {
  return Object.assign({}, state, {
    diamondResults: action.diamonds,
    diamondResultsCount: action.diamondCount,
    currentDiamondPage: 1,
  });
}

function productAppendDiamondResults(state, action) {
  const moreDiamonds = state.diamondResults.concat(action.diamonds);
  return Object.assign({}, state, {
    diamondResults: moreDiamonds,
    currentDiamondPage: state.currentDiamondPage + 1,
  });
}

function productAddDiamondsResults(state, action) {
  
  let newDiamonds = [];
  for(let i = 0; i < state.diamondResults.length; i++) {
    newDiamonds.push(state.diamondResults[i]);
  }

  for(let j = 0; j < action.diamonds.length; j++) {
    newDiamonds.push(action.diamonds[j]);
  }

  return Object.assign({}, state, {
    diamondResults: newDiamonds,
    currentDiamondPage: action.diamondPage,
  });
}

function productSaveSettingResults(state, action) {
  return Object.assign({}, state, {
    productResults: action.products,
    productResultsCount: action.productCount,
  });
}

function productSaveDiamondFilters(state, action) {

  let mergedFilters = Object.assign({}, state.diamondFilters, action.filters);
  // storage.put('diamondFilters', JSON.stringify(mergedFilters));

  return Object.assign({}, state, {
    diamondFilters: mergedFilters,
    productResultsType: action.queryType,
    diamondResults: null,
    currentPage: action.pageNum,
    currentDiamondPage: 1,
  });
}

function productResetDiamondFilters(state, action) {

  let mergedFilters = Object.assign({}, initDiamonds);
  return Object.assign({}, state, {
    diamondFilters: initDiamonds,
    diamondResults: null,
    currentPage: 1,
    currentDiamondPage: 1,
  });
}

function productSaveSettingFilters(state, action) {
  
  // queryType options:
  // setting
  // mensband
  // womensband
  // fashion

  let mergedFilters = null;
  switch(action.queryType) {
    case 'setting':
      mergedFilters = Object.assign({}, initSettings, state.productFilters, action.filters);
      break;
    case 'mensband':
      mergedFilters = Object.assign({}, initMensBand, state.productFilters, action.filters);
      break;
    case 'womensband':
      mergedFilters = Object.assign({}, initWomensBand, state.productFilters, action.filters);
      break;
    case 'fashion':
      mergedFilters = Object.assign({}, initFashion, state.productFilters, action.filters);
      break;
    case 'mens':
      mergedFilters = Object.assign({}, initMensJewelry, state.productFilters, action.filters);
      break;
    default:
      mergedFilters = Object.assign({}, state.productFilters, action.filters);
  }

  // storage.put('productFilters', JSON.stringify(mergedFilters));

  return Object.assign({}, state, {
    productFilters: mergedFilters,
    productResults: null,
    currentPage: action.pageNum,
  });
}

function productResetProductFilters(state, action) {
  
  // queryType options:
  // setting
  // mensband
  // womensband
  // fashion

  let mergedFilters = null;
  switch(action.queryType) {
    case 'setting':
      mergedFilters = Object.assign({}, initSettings);
      break;
    case 'mensband':
      mergedFilters = Object.assign({}, initMensBand);
      break;
    case 'womensband':
      mergedFilters = Object.assign({}, initWomensBand);
      break;
    case 'fashion':
      mergedFilters = Object.assign({}, initFashion);
      break;
    default:
      mergedFilters = Object.assign({});
  }

  return Object.assign({}, state, {
    productFilters: mergedFilters,
    productResults: null,
    currentPage: 1,
  });
}

function productSelectSetting(state, action) {

  storage.put('selectedSetting', JSON.stringify(action.setting));

  if(action.metalType) {
    storage.put('attrMetal', action.metalType);
  }

  if(action.ringSize) {
    storage.put('attrSize', action.ringSize);
  }

  return Object.assign({}, state, {
    selectedSetting: action.setting,
    attrSize: action.ringSize,
    attrMetal: action.metalType,
  });
}

function productSelectDiamond(state, action) {

  storage.put('selectedDiamond', JSON.stringify(action.diamond));

  return Object.assign({}, state, {
    selectedDiamond: action.diamond,
  });
}

function productCompareSetting(state, action) {
  return Object.assign({}, state, {
    compareSettings: action.setting,
  });
}

function productCompareDiamond(state, action) {

  storage.put('compareDiamonds', JSON.stringify(action.diamond));

  return Object.assign({}, state, {
    compareDiamonds: action.diamond,
  });
}

function productCompareBand(state, action) {
  return Object.assign({}, state, {
    compareBands: action.band,
  });
}

function productCompareFashion(state, action) {
  return Object.assign({}, state, {
    compareFashion: action.jewelry,
  });
}

function productClearQuery(state, action) {

  // storage.put('diamondFilters', JSON.stringify(initDiamonds));
  // storage.put('productFilters', JSON.stringify(initSettings));

  return Object.assign({}, state, {
    diamondResults: null,
    diamondResultsCount: null,
    diamondFilters: initDiamonds,
    
    productResults: null,
    productResultsCount: null,
    productResultsType: null,
    productFilters: {},
    currentPage: 1,
    currentDiamondPage: 1,
  });
}

function productSetPage(state, action) {
  return Object.assign({}, state, {
    currentPage: action.page,
  });
}

function productAttrSize(state, action) {
  return Object.assign({}, state, {
    attrSize: action.size,
  });
}

function productAttrMetal(state, action) {
  return Object.assign({}, state, {
    attrMetal: action.metal,
  });
}

function productToggleFloatingHeader(state, action) {
  return Object.assign({}, state, {
    floatingHeaderOpen: action.position,
  });
}




// WEBPACK FOOTER //
// ./src/reducers/product.jsx